import React, { Children, cloneElement } from 'react';
import { classNames } from '@panwds/tailwindcss';
import { useOptionallyControlledState } from '../../utils/useOptionallyControlledState.js';
function canClone(arg) {
    return arg?.props !== undefined;
}
/**
 * An accordion is a vertically stacked list of headers that reveal or hide associated sections of content.
 *
 * The accordion component delivers large amounts of content in a small space through progressive disclosure.
 * The header title give the user a high level overview of the content allowing the user to decide which sections to read.
 */
export function Accordion({ allowMultipleOpen = false, allowNoneOpen = false, children, dataMetrics, dataTestId, defaultOpenPanels = [0], level = 4, openPanels: userOpenPanels, addClassName = '', onChangeOpenPanels }) {
    const [openPanels, setOpenPanels] = useOptionallyControlledState({
        currentValue: userOpenPanels,
        defaultValue: defaultOpenPanels,
        onChange: onChangeOpenPanels
    });
    const panels = Children.map(children, (child, index) => {
        if (!canClone(child))
            return child;
        const isOpen = openPanels.includes(index);
        const canClose = allowNoneOpen || openPanels.length > 1;
        return cloneElement(child, {
            canClose,
            isOpen,
            level,
            onClick() {
                if (canClose && isOpen) {
                    return setOpenPanels(openPanels.filter((panelIndex) => panelIndex !== index));
                }
                if (!isOpen && allowMultipleOpen) {
                    return setOpenPanels(openPanels.concat(index));
                }
                setOpenPanels([index]);
            },
            ...child.props
        });
    });
    return (React.createElement("ul", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'accordion', className: classNames('tw-box-border tw-p-0 tw-m-0 tw-flex tw-flex-col', addClassName) }, panels));
}
//# sourceMappingURL=Accordion.js.map